<template>
  <div id="publishing-volume-issue">
    <div class="ipub-h1 mar-b-20 relative">Volume & Issue
      <div class="right-option ipub-p1">
        <ipub-button type="primary"
                     icon="iconAdd"
                     v-if="user.codeList&&user.codeList.includes('WEBSITE.VOLUME_ISSUE.PRE_PUBLISHER.EDIT')"
                     @click="addPre">
          Set Pre-Publisher
        </ipub-button>
        <ipub-button type="primary"
                     icon="iconAdd"
                     v-if="user.codeList&&user.codeList.includes('WEBSITE.VOLUME_ISSUE.ADD')"
                     @click="add">
          Add Volume & Issue
        </ipub-button>
      </div>
    </div>
    <div class="mar-b-20 flex ipub-p1">
      <div class="flex">
        <span class="line-h-40">Journal</span>
        <ipub-select v-model="params.journalId"
                     style="width:200px"
                     placeholder="Select Journal"
                     class="mar-l-20 ipub-p2"
                     @change="getVolumeCode"
                     :options="journalList" />
      </div>
      <div class="flex mar-l-20">
        <span style=""
              class="line-h-40">Volume & Issue</span>
        <ipub-select class="mar-l-12 ipub-p2"
                     style="width:200px"
                     placeholder="Select Volume"
                     v-model="params.volumeId"
                     optionTitle="code"
                     @change="getIssueCode"
                     :options="volumeList" />
        <ipub-select class="mar-l-10 ipub-p2"
                     style="width:200px"
                     placeholder="Select Issue"
                     optionTitle="code"
                     :disabled="!params.volumeId"
                     @change="getList"
                     v-model="params.issueId"
                     :options="issueList" />
      </div>

    </div>
    <div class="ipub-list-tab"
         style="margin-bottom:20px">
      <a @click="changeStatus('')"
         :class="['ipub-list-tab--status',params.released===''?'active':'']">All Status</a>
      <a @click="changeStatus(true)"
         :class="['ipub-list-tab--status',params.released===true?'active':'']">Published</a>
      <a @click="changeStatus(false)"
         :class="['ipub-list-tab--status',params.released===false?'active':'']">Draft</a>
    </div>
    <div class="page-content">
      <div v-for="item in dataSource"
           :class="['mar-b-12 border-style']"
           :key="item.id || item.name">
        <a @click="selectSection(item.id)">
          <div :class="['ipub-p1', 'mar-b-10',' relative',]">
            Volume {{item.code}} ({{item.year}})
            <ipub-icon :class="['mar-l-10 ipub-p2 rotate',openSection === item.id?'':'rotate-180']"
                       type="iconArrow" />
          </div>
        </a>
        <ipub-table v-if="openSection === item.id && item.issueList && item.issueList.length"
                    :columns="columns"
                    draggable
                    emptyText="There is no Volume & Issue."
                    @drag="setSort"
                    :showColumns="false"
                    :pagination="false"
                    :dataSource="item.issueList">
          <template v-slot:time="{record}">
            {{ (record.updateTime||record.createTime)?$moment(record.updateTime||record.createTime).format('HH : mm DD / MM / YYYY'): '- -' }}
          </template>
          <template v-slot:img="{text, record}">
            <router-link :to="`/publishing/volume-issue/articles/${record.id}?vol=${item.code}&issue=${record.code}`">
              <img class="ipub-table-slot-img"
                   style="height: 100px"
                   :src="`${domain}/${text}`"
                   alt="">
            </router-link>
          </template>
          <template v-slot:name="{record}">
            <div>
              <ipub-label v-if="record.released"
                          class="mar-b-10"
                          size="small"
                          style="width:80px"
                          cover
                          type="success">Published</ipub-label>
              <ipub-label v-else
                          class="mar-b-10"
                          size="small"
                          style="width:80px"
                          cover
                          type="danger">Draft</ipub-label>
              <div class="ipub-p2 fw-bd">
                <template v-if="record.forthcomingIssue">Forthcoming Issue: </template>
                Vol {{item.code}}, Issue {{record.code}}
              </div>
              <div class="ipub-p4 ipub-flex-center">
                <!-- <div :class="['ipub-table-status-show', record.released?'ipub-table-status-show--active':'']"></div> -->
                <div>Published Time: {{$moment(record.releaseTime).format('DD / MM / YYYY')}}</div>
              </div>
            </div>
          </template>
          <template v-slot:downloadNum="{text}">
            Download: {{text||0}}
          </template>
          <template v-slot:readNum="{text}">
            View: {{text||0}}
          </template>
          <template v-slot:actions="{ record }">
            <ipub-tooltip v-show="user.codeList&&user.codeList.includes('WEBSITE.VOLUME_ISSUE.EDIT')"
                          class="border-right">
              <div slot="title">Edit</div>
              <ipub-icon type="iconEdit"
                         @click="edit(record)" />
            </ipub-tooltip>
            <ipub-tooltip v-show="user.codeList&&user.codeList.includes('WEBSITE.VOLUME_ISSUE.DATABASE_FILES.EXPORT')"
                          action="click">
              <!-- <div slot="title">Export XML</div> -->
              <div style="font-size:14px;padding:5px 0"
                   class="ipub-cursor-pointer"
                   slot="title">
                <div @click="exportXML(record,'DOI')">
                  <ipub-icon type="iconDOI" />DOI
                </div>
                <div @click="exportXML(record,'DOAJ')">
                  <ipub-icon type="iconDOAJ" />DOAJ
                </div>
                <div @click="exportXML(record,'PUBMED')">
                  <ipub-icon type="iconPubMed1" />PubMed
                </div>
                <div @click="exportXML(record,'RESEARCH_GATE')">
                  <ipub-icon type="iconPubMed1" />Research Gate
                </div>
              </div>
              <ipub-icon type="iconXML" />
            </ipub-tooltip>
            <ipub-tooltip class="border-right"
                          v-show="user.codeList&&user.codeList.includes('WEBSITE.VOLUME_ISSUE.XML.EDIT')">
              <div slot="title">Update XML</div>
              <ipub-icon @click="updateXML(record)"
                         type="icona-updateXML" />
            </ipub-tooltip>
            <ipub-tooltip class="border-right"
                          v-show="user.codeList&&user.codeList.includes('WEBSITE.VOLUME_ISSUE.REGISTER_DOI')">
              <div slot="title">Register DOI</div>
              <ipub-icon @click="updateDOI(record)"
                         type="iconRegisterDOI" />
            </ipub-tooltip>
            <template v-if="user.codeList&&user.codeList.includes('WEBSITE.VOLUME_ISSUE.PUBLISH')">
              <ipub-tooltip v-if="record.released"
                            class="border-right">
                <div slot="title">Unpublish</div>
                <ipub-icon type="iconDisable"
                           @click="able(record)" />
              </ipub-tooltip>
              <ipub-tooltip v-else
                            class="border-right">
                <div slot="title">Publish</div>
                <ipub-icon type="iconAble"
                           @click="able(record)" />
              </ipub-tooltip>
            </template>
            <ipub-tooltip v-if="user.codeList&&user.codeList.includes('WEBSITE.VOLUME_ISSUE.DELETE')">
              <div slot="title">Delete</div>
              <ipub-icon type="iconDelete"
                         @click="del(record)" />
            </ipub-tooltip>
          </template>
        </ipub-table>
      </div>
    </div>
    <div>
      <div class="ipub-h2 mar-b-10">Pre-Publisher</div>
      <div v-for="item in preDataSource"
           :class="['mar-b-12 border-style']"
           :key="item.id || item.name">
        <a @click="selectSection(item.id)">
          <div :class="['ipub-p1', 'mar-b-10',' relative']">
            Volume {{item.code}} ({{item.year}})
            <ipub-icon :class="['mar-l-10 ipub-p2 rotate',openSection === item.id?'':'rotate-180']"
                       type="iconArrow" />
          </div>
        </a>
        <ipub-table v-if="openSection === item.id && item.issueList && item.issueList.length"
                    :columns="columns"
                    draggable
                    @drag="setSort"
                    :showColumns="false"
                    :pagination="false"
                    :dataSource="item.issueList">
          <template v-slot:time="{record}">
            {{ (record.updateTime||record.createTime)?$moment(record.updateTime||record.createTime).format('HH : mm DD / MM / YYYY'): '- -' }}
          </template>
          <template v-slot:img="{text, record}">
            <router-link :to="`/publishing/volume-issue/articles/${record.id}?vol=${item.code}&issue=${record.code}`">
              <img class="ipub-table-slot-img"
                   style="height: 100px"
                   :src="`${domain}/${text}`"
                   alt="">
            </router-link>
          </template>
          <template v-slot:name="{record}">
            <div>
              <ipub-label v-if="record.released"
                          cover
                          class="mar-b-10"
                          size="small"
                          type="success">Published</ipub-label>
              <ipub-label v-else
                          class="mar-b-10"
                          size="small"
                          cover
                          type="danger">Draft</ipub-label>
              <div class="ipub-p2 fw-bd">
                <template v-if="record.forthcomingIssue">Forthcoming Issue: </template>
                Vol {{item.code}}, Issue {{record.code}}
              </div>
              <div class="ipub-p2 ipub-flex-center">
                <!-- <div :class="['ipub-table-status-show', record.released?'ipub-table-status-show--active':'']"></div> -->
                <div>Published Time: {{$moment(record.releaseTime).format('DD / MM / YYYY')}}</div>
              </div>
            </div>
          </template>
          <template v-slot:downloadNum="{text}">
            Download: {{text||0}}
          </template>
          <template v-slot:readNum="{text}">
            View: {{text||0}}
          </template>
          <template v-slot:actions="{ record }">
            <ipub-tooltip v-show="user.codeList&&user.codeList.includes('WEBSITE.VOLUME_ISSUE.EDIT')"
                          class="border-right">
              <div slot="title">Edit</div>
              <ipub-icon type="iconEdit"
                         @click="edit(record)" />
            </ipub-tooltip>
            <ipub-tooltip class="border-right">
              <!-- <div slot="title">Export XML</div> -->
              <div style="font-size:14px;padding:5px 0"
                   class="ipub-cursor-pointer"
                   slot="title">
                <div @click="exportXML(record,'DOI')">
                  <ipub-icon type="iconXML" />DOI
                </div>
                <div @click="exportXML(record,'DOAJ')">
                  <ipub-icon type="iconPDF1" />DOAJ
                </div>
                <div @click="exportXML(record,'PUBMED')">
                  <ipub-icon type="iconPDF" />PUBMED
                </div>
              </div>
              <ipub-icon type="iconXML" />

            </ipub-tooltip>
            <ipub-tooltip class="border-right">
              <div slot="title">Update XML</div>
              <ipub-icon @click="updateXML(record)"
                         type="icona-updateXML" />
            </ipub-tooltip>
            <template>
              <ipub-tooltip v-if="record.released"
                            class="border-right">
                <div slot="title">Unpublish</div>
                <ipub-icon type="iconDisable"
                           @click="able(record)" />
              </ipub-tooltip>
              <ipub-tooltip v-else
                            class="border-right">
                <div slot="title">Publish</div>
                <ipub-icon type="iconAble"
                           @click="able(record)" />
              </ipub-tooltip>
            </template>
            <ipub-tooltip v-if="user.codeList&&user.codeList.includes('WEBSITE.VOLUME_ISSUE.DELETE')">
              <div slot="title">Delete</div>
              <ipub-icon type="iconDelete"
                         @click="del(record)" />
            </ipub-tooltip>
          </template>
        </ipub-table>
      </div>
    </div>
    <Add ref="volume-issue-add"
         :isVisable="isVisable"
         :inputData="inputData"
         @confirm="confirm"
         @cancel="cancel" />
    <addPre :isVisable="isVisablePre"
            @confirm="confirm"
            @cancel="cancel"
            :volumeList="volumeList"
            :journalId="params.journalId">
    </addPre>
    <Progress :isVisable="isVisableProgress"
              :inputData="inputData"
              @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
.border-style {
  border-bottom: 1px solid $line_color;
  padding-bottom: 12px;
  &:nth-last-child(1) {
    border-bottom: none;
  }
}
</style>

<script>
import main from './main'
export default main
</script>
